// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2cXs3","select":"Header_select__1cJCH","clinic":"Header_clinic__1U6f7"};